import { PayloadAction } from '@reduxjs/toolkit';

import { LivePreviewSize, LivePreviewState } from '../types';

const setSizeReducer = (state: LivePreviewState, action: PayloadAction<LivePreviewSize>) => {
  state.size = action.payload;
  if (action.payload !== 'expanded') {
    // Leaving expanded also drops the dragged width, so the corner handle never keeps a size
    // alive behind a card that is no longer showing it.
    state.expandedWidth = undefined;
  }
};

export default setSizeReducer;
